import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import { Stack } from "@mui/system";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { LogoDropzone } from "../../settings/pages/ChangeLogoInDashbaordPage";

const LocationMasterForm = ({
  setFiles,
  files,
  selectedRow,
  open,
  buttonHandle,
  isDisabled,
  handleChange,
  handleClose,
  handleSave,
  handleSaveEdit,
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <DialogTitle className="text-[#312C41] !text-[16px] !font-semibold">
            {buttonHandle === "Add" ? "Add" : "Edit"}
          </DialogTitle>

          <CancelRoundedIcon
            sx={{ cursor: "pointer" }}
            onClick={handleClose}
            className="bg-[white] !text-[#344767] !text-[1.7rem] !outline-none p-4"
          />
        </Box>

        <DialogContent>
          <Stack spacing={4} paddingLeft={4} paddingRight={4} paddingBottom={2}>
            <div className="grid grid-cols-2 gap-4">
              <TextField
                required
                name="name"
                type="text"
                id="outlined-required"
                label="Name"
                size="small"
                onChange={handleChange}
                value={selectedRow ? selectedRow.name : ""}
              />
              <TextField
                required
                name="description"
                type="text"
                id="outlined-required"
                label="Description"
                size="small"
                value={selectedRow ? selectedRow.description : ""}
                onChange={handleChange}
              />
              <TextField
                required
                name="address"
                type="text"
                id="outlined-required"
                label="Address"
                size="small"
                value={selectedRow ? selectedRow.address : ""}
                onChange={handleChange}
              />
              <TextField
                required
                name="gstNo"
                type="text"
                id="outlined-required"
                label="Gst Number"
                size="small"
                value={selectedRow ? selectedRow.gstNo : ""}
                onChange={handleChange}
              />
               <TextField
                required
                name="upiId"
                type="text"
                id="outlined-required"
                label="Upi ID"
                size="small"
                value={selectedRow ? selectedRow.upiId : ""}
                onChange={handleChange}
              />
              <div className="col-span-2">
              <LogoDropzone {...{ files, setFiles }} />
              </div>
            </div>

            <Button
              disabled={!isDisabled}
              onClick={buttonHandle === "Add" ? handleSave : handleSaveEdit}
              sx={{
                textTransform: "none",
                background: !isDisabled
                  ? "gray"
                  : "linear-gradient(135deg, #3A416F 0%, #141727 100%)",
                color: "white",
                "&:hover": {},
              }}
            >
              {buttonHandle === "Add" ? "Submit" : "Update"}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LocationMasterForm;
